import { render, staticRenderFns } from "./formBlock.vue?vue&type=template&id=1be8940c&scoped=true&"
import script from "./formBlock.vue?vue&type=script&lang=js&"
export * from "./formBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8940c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VDivider,VLazy})
